module.exports = __webpack_public_path__ + "img/repeatImg.8775e442.png";